var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoToOrderbookTipMobileDot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 49,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#00D6AF",
  opacity: 0.2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 7,
  fill: "#00D6AF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00D6AF",
  strokeDasharray: "2 2",
  d: "M12.5 19v30"
})));
export default SvgGoToOrderbookTipMobileDot;